import { CoordonneesSimplifie } from "@enums/coordonnes-simplifie.enum";
import { CoordonneesSimplifieAvecKmWSDTO } from "@jack-sparrow-libraries/angular-business-commons";

export class CoordonneesMapperService {
	static coordonneesSimplifieToCoordonneesSimplifieAvecKmWSDTO(
		coordonnees: CoordonneesSimplifie,
	): CoordonneesSimplifieAvecKmWSDTO {
		return {
			__brand: "DTO",
			id: coordonnees.id,
			adresse: coordonnees.adresse,
			adresse2: coordonnees.adresse2,
			codePostal: coordonnees.codePostal,
			ville: coordonnees.ville,
			email: coordonnees.email,
			fax: coordonnees.fax,
			fixe: coordonnees.fixe,
			mobile: coordonnees.mobile,
			nbKmMontagne: coordonnees.nbKmMontagne,
			nbKmPlaine: coordonnees.nbKmPlaine,
			nbKmSki: coordonnees.nbKmSki,
		};
	}
}
